import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'
const BASE_PATH = 'business'

const client = new ApiClient(API_NAME)

export default {
  get(business_id) {
    return client.get(`/${BASE_PATH}/${business_id}/category/`)
  },

  getContext(business_id, category_id) {
    return client.get(`/business/${business_id}/category/${category_id}`)
  },

  getItem(business_id, category_id, offset) {
    const query = {}

    if (category_id) {
      query.category_id = category_id
    }

    if (offset) {
      query.offset_item_id = offset
    }

    query.bookmark_only = 'false'

    return client.get(`/${BASE_PATH}/${business_id}/itemselect`, query)
  },

  getBookmarkItem(business_id, category_id, offset) {
    const query = {}

    if (category_id) {
      query.category_id = category_id
    }

    if (offset) {
      query.offset_item_id = offset
    }

    query.bookmark_only = 'true'

    return client.get(`/${BASE_PATH}/${business_id}/itemselect`, query)
  },

  updateBookmark(business_id, data) {
    return client.put(`/business/${business_id}/itemselect/bookmark`, data)
  },

  lock(business_id, data) {
    return client.put(`/business/${business_id}/category/lock`, data)
  }
}
